import { Toast } from 'primereact/toast'
import React, { useEffect, useRef, useState } from 'react'
import api from '../../services/api'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/pt-br'
import { Line } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

dayjs.extend(customParseFormat)

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ChartDataLabels)

const currencyFormatter = (value) =>
    Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)

const Recebimentos = ({ data_inicial, data_final, categoria_id, initBuscarItens, onBuscarItensEnd }) => {
    const [loading, setLoading] = useState(false)
    const toast = useRef(null)
    const [data, setData] = useState([])

    const buscarItens = async () => {
        try {
            setLoading(true)
            let url = '/api/recebimentos?data_inicio=' + dayjs(data_inicial).format('DD/MM/YYYY') + '&data_fim=' + dayjs(data_final).format('DD/MM/YYYY')

            if (categoria_id) {
                url += '&categoria_id=' + categoria_id
            }

            const response = await api.get(url)
            setData(response.data)
        } catch (e) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: e.response?.data?.message || 'Erro ao realizar operação', life: 3000 });
        } finally {
            setLoading(false)
            onBuscarItensEnd()
        }
    }

    useEffect(() => {
        if (initBuscarItens) {
            buscarItens()
        }
    }, [initBuscarItens, categoria_id])

    return (
        <div>
            <Toast ref={toast} position="top-center" />

            {loading && (
                <div className='flex justify-center items-center'>
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                </div>
            )}

            {!loading && data.length > 0 && (
                <div className="chart-container">
                    <Line
                        options={{
                            scales: {
                                y: {
                                    beginAtZero: true,
                                    ticks: {
                                        callback: (value) => currencyFormatter(value)
                                    }
                                }
                            },
                            plugins: {
                                datalabels: {
                                    display: true,
                                    align: 'top',
                                    color: '#000',
                                    font: {
                                        weight: 'bold',
                                        size: 10
                                    },
                                    formatter: (value) => currencyFormatter(value)
                                }
                            }
                        }}
                        data={{
                            labels: data.map(d => d.data),
                            datasets: [
                                {
                                    label: 'Faturados',
                                    data: data.map(d => d.faturados),
                                    fill: false,
                                    backgroundColor: 'rgb(54, 162, 235)',
                                    borderColor: 'rgb(54, 162, 235)',
                                    tension: 0.3
                                },
                                {
                                    label: 'Recebidos',
                                    data: data.map(d => d.recebidos),
                                    fill: false,
                                    backgroundColor: 'rgb(75, 192, 75)',
                                    borderColor: 'rgb(75, 192, 75)',
                                    tension: 0.3
                                },
                                {
                                    label: 'Em Aberto',
                                    data: data.map(d => d.em_aberto),
                                    fill: false,
                                    backgroundColor: 'rgb(255, 159, 64)',
                                    borderColor: 'rgb(255, 159, 64)',
                                    tension: 0.3
                                },
                                {
                                    label: 'Cancelados',
                                    data: data.map(d => d.cancelados),
                                    fill: false,
                                    backgroundColor: 'rgb(255, 99, 132)',
                                    borderColor: 'rgb(255, 99, 132)',
                                    tension: 0.3
                                }
                            ],
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default Recebimentos
